import React, { useState, useEffect } from 'react';
import { Layout, Menu, Badge, Drawer } from 'antd';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import {
  DashboardOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  HistoryOutlined,
  ProductOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  HeartOutlined,
  MenuOutlined, // Hamburger menu icon
  OrderedListOutlined
} from '@ant-design/icons';
import './Homepagecomponent.css';
import logo from './logo-icon.png';
import Colors from './libs/Colors';
import { hosturl } from '../libs/Constants';

const { Header, Sider, Content } = Layout;

const HomepageComponent = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedKey, setSelectedKey] = useState('1');
  const [cartCount, setCartCount] = useState(0); // For cart count badge
  const [wishlistCount, setWishlistCount] = useState(0); // For wishlist count badge
  const [drawerVisible, setDrawerVisible] = useState(false); // Drawer visibility
  const navigate = useNavigate();

  const fetchUser = async () => {
    try {
      const response = await fetch(`${hosturl}/users`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setUser(data.user);
      } else {
        setError(data.message || 'An error occurred');
      }
    } catch (err) {
      setError('Failed to fetch user data');
    }
  };

  const handleResize = () => {
    const mobileView = window.innerWidth <= 768;
    setIsMobileView(mobileView);
    setCollapsed(mobileView);
  };

  useEffect(() => {
    fetchUser();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    // Clear relevant data from local storage
    localStorage.removeItem('name');
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('token');
    window.location.href = 'https://raoosastro.com?logout=true';  // Add logout=true query parameter
  };
  

  const handleMenuSelect = ({ key }) => {
    setSelectedKey(key);
  };

  // Add custom state to show/hide the overlay
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const openDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        className={`sidebar ${collapsed ? 'collapsed' : ''}`}
        width={250}
        collapsedWidth={50}
        collapsible={!isMobileView}
        collapsed={collapsed}
        breakpoint="md"
        onCollapse={(collapsed) => setCollapsed(collapsed)}
      >
        {!collapsed ? (
          <div className="sidebar-header">
            <img src={logo} width={180} height={50} style={{ marginLeft: '10px' }} />
          </div>
        ) : (
          <div style={{ marginTop: 20, marginBottom: 20, display: 'flex', justifyContent: 'center' }} />
        )}
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onSelect={handleMenuSelect}
          className="custom-menu"
        >
          <Menu.Item key="1" icon={<DashboardOutlined />}><Link to="/home">Dashboard</Link></Menu.Item>
          <Menu.Item key="2" icon={<OrderedListOutlined />}><Link to="/orders">Shop Orders</Link></Menu.Item>
          <Menu.Item key="3" icon={<HistoryOutlined />}><Link to="/shoppayments">Shop Payments</Link></Menu.Item>
          <Menu.Item key="4" icon={<HistoryOutlined />}><Link to="/paymenthistory">Appointment Payments</Link></Menu.Item>
          <Menu.Item key="5" icon={<UserOutlined />}><Link to="/profile">Profile</Link></Menu.Item>
          <Menu.Item key="6" icon={<UsergroupAddOutlined />}><a href="https://raoosastro.com/contact-us/" rel="noopener noreferrer">Help & Support</a></Menu.Item>

        </Menu>
      </Sider>

      <Layout>
        <Header className="header" style={{ padding: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {isMobileView ? (
            // Hamburger menu for mobile
            <MenuOutlined onClick={openDrawer} style={{ fontSize: '24px', padding: '10px', cursor: 'pointer' }} />
          ) : (
            <Menu
              mode="horizontal"
              style={{ display: 'flex', flex: 1, gap: 10, marginLeft: '50px' }}  // The main menu items on the left
            >
              <Menu.Item key="home" className="menu-item">
              <a href="https://raoosastro.com" rel="noopener noreferrer">Home</a>
              </Menu.Item>
              <Menu.Item key="shop" className="menu-item">
                <a href="https://raoosastro.com/our-products" rel="noopener noreferrer">Shop</a>
              </Menu.Item>
              <Menu.Item key="contactus" className="menu-item">
                <a href="https://raoosastro.com/contact-us/"  rel="noopener noreferrer">Contact Us</a>
              </Menu.Item>
            </Menu>
          )}

            <Menu
        mode="horizontal"
        style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight:'10px' }}  // Align wishlist, cart, logout to the right
      >
        {/* Wishlist Icon */}
        <Menu.Item key="wishlist" className="menu-item">
          <a href="https://raoosastro.com/wish-list">
            <HeartOutlined style={{ fontSize: '18px', fontWeight: 'bold' }} />
          </a>
        </Menu.Item>

        {/* Cart Icon */}
        <Menu.Item key="cart" className="menu-item">
          <a href="https://raoosastro.com/shop-cart">
            <ShoppingCartOutlined style={{ fontSize: '18px', fontWeight: 'bold' }} />
          </a>
        </Menu.Item>

        {/* Logout Icon */}
        <Menu.Item key="logout" className="menu-item" onClick={handleLogout}>
            <LogoutOutlined style={{ fontSize: '18px', fontWeight: 'bold' }} />
        </Menu.Item>
      </Menu>

        </Header>

        {/* Drawer for mobile menu */}
        <Drawer
          title="Menu"
          placement="left"
          onClose={closeDrawer}
          visible={drawerVisible}
          width={250}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            onSelect={handleMenuSelect}
            className="custom-menu"
          >
            <Menu.Item key="1" icon={<DashboardOutlined />}><Link to="/home">Dashboard</Link></Menu.Item>
            <Menu.Item key="2" icon={<OrderedListOutlined />}><Link to="/orders">Shop Orders</Link></Menu.Item>
            <Menu.Item key="3" icon={<HistoryOutlined />}><Link to="/shoppayments">Shop Payments</Link></Menu.Item>
            <Menu.Item key="4" icon={<HistoryOutlined />}><Link to="/paymenthistory">Appointment Payments</Link></Menu.Item>
            <Menu.Item key="5" icon={<UserOutlined />}><Link to="/profile">Profile</Link></Menu.Item>
            <Menu.Item key="6" icon={<UsergroupAddOutlined />}><a href="https://raoosastro.com/contact-us/"rel="noopener noreferrer">Help & Support</a></Menu.Item>
            <Menu.Item key="7" icon={<LogoutOutlined />} onClick={handleLogout}>Logout</Menu.Item>
          </Menu>
        </Drawer>

        <Content style={{ overflow: 'auto', height: 'calc(100vh - 64px)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default HomepageComponent;
